import { createTheme } from '@mui/material/styles';
import { createTheme as createMuiV5Theme } from '@mui/material/styles';
import { brandColors, semanticColors, neutralColors } from './tokens/colors';
import { mobileTypography } from './tokens/typography';

const themeConfig = (direction = 'rtl') => ({
        direction,
        typography: {
            fontFamily: "'Heebo', sans-serif",
            allVariants: {
                color: semanticColors.textPrimary,
            },
            body2: {
                ...mobileTypography.bodySm,
            },
            body1: {
                ...mobileTypography.bodyMd,
            },
            h6: {
                ...mobileTypography.titleSm,
            },
            h5: {
                ...mobileTypography.titleMd,
            },
            mobileLabelXs: {
                ...mobileTypography.labelXs,
            },
            mobileLabelSm: {
                ...mobileTypography.labelSm,
            },
            mobileBodySm: {
                ...mobileTypography.bodySm,
            },
            mobileBodyMd: {
                ...mobileTypography.bodyMd,
            },
            mobileTitleSm: {
                ...mobileTypography.titleSm,
            },
            mobileTitleMd: {
                ...mobileTypography.titleMd,
            },
        },
        palette: {
            primary: {
                main: brandColors.blue,
            },
            secondary: {
                main: brandColors.red,
            },
            error: {
                main: brandColors.red,
            },
            warning: {
                main: brandColors.yellow,
            },
            success: {
                main: brandColors.green,
            },
            background: {
                default: semanticColors.appBackground,
                paper: semanticColors.surface,
            },
            text: {
                primary: semanticColors.textPrimary,
            },
            neutral: neutralColors,
        },
    });

export const createAppTheme = (direction = 'rtl') => createTheme(themeConfig(direction));

export const createAppV5Theme = (direction = 'rtl') => createMuiV5Theme({
    ...themeConfig(direction),
    components: {
        // Prevent MUI v5 AppBar default color="primary" from overriding app background.
        // The JSS @mui/styles class sets backgroundColor but Emotion injects later and wins.
        // color="inherit" disables MUI's automatic background-color assignment.
        MuiAppBar: {
            defaultProps: {
                color: 'inherit',
            },
            styleOverrides: {
                root: {
                    backgroundColor: semanticColors.appBackground,
                    color: semanticColors.textPrimary,
                    boxShadow: 'none',
                },
            },
        },
        // Prevent MUI v5 Accordion default elevation/box-shadow and ::before divider line.
        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    '&:before': {
                        display: 'none',
                    },
                },
            },
        },
        // Prevent MUI v5 Paper default elevation from adding box-shadow to BottomNavigation.
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
        },
        // Prevent MUI v5 Container default horizontal padding (16px) from overriding JSS padding:0.
        // App root Container uses classes.appRoot which has padding:0, but Emotion injects after JSS.
        // disableGutters as default ensures all Containers are gutter-free by default.
        MuiContainer: {
            defaultProps: {
                disableGutters: true,
            },
        },
    },
});

export { brandColors, semanticColors };
